import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IsFormDataEnabled } from '@core/context';
import { map, Observable } from 'rxjs';

import { skipToastOnErrorContext } from '../context/skip-toast-on-error.context';
import { ApiAbstraction } from './api.abstraction';

@Injectable()
export class AssetsAiTaggingApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public getAiTaggingFields(model: AssetAiSuggestionInputDAO): Observable<AiTaggingFields> {
    const context = new HttpContext();
    context.set(skipToastOnErrorContext, true);
    return this.httpClient.post<AiTaggingFields>(`${this.baseUrl}/ai/tag`, model, { context });
  }

  public generateAltText(input: File | string): Observable<string> {
    const isFile = input instanceof File;
    const formData = new FormData();
    if (isFile) {
      formData.append('file', input);
    } else {
      formData.append('imageUrl', input);
    }

    const context = new HttpContext().set(IsFormDataEnabled, true);
    return this.httpClient
      .post<{ altText: string }>(`${this.baseUrl}/ai/generate-alt-text`, formData, { context })
      .pipe(map(response => response.altText));
  }

  public analyzeStandards(payload: AnalyzeEducationStandardInputDAO): Observable<AnalyzeEducationStandardDAO> {
    return this.httpClient.post<AnalyzeEducationStandardDAO>(`${this.baseUrl}/ai/analyze-standards`, payload);
  }

  public createBulkAssets(unitId: ID, payload: UploadBulkAssetInputDAO): Observable<unknown> {
    return this.httpClient.post<UploadBulkAssetInputDAO>(`${this.baseUrl}/ai/units/${unitId}/bulk-upload`, payload);
  }
}
